<div class="contentDiv">
  <div class="analyst-details">
    <div id="analyst_fn_ln" [textContent]="analystName"></div>
    <div id="broker_link">
      <a routerLink="/reporting/broker/{{ sourceSn }}" routerLinkActive="active"
        >{{ sourceName }} &rsquo;s Broker Home Page</a
      >
    </div>
  </div>
  <div class="analyst-data">
    <div class="filter-container">
      <app-global-reporting-filters
        showModelOnly="false"
        [isSearchFilter]="showSearch"
        [exportColumns]="exportColumns"
        [exportKey]="exportKey"
        (isFilterValueChange)="toggleFilter($event)"
        (onGlobalFilterChange)="onSearch($event)"
        (onReloadGrid)="onReloadGrid()"
      ></app-global-reporting-filters>
    </div>
    <div class="grid-container">
      <app-reporting-grid-wrapper
        [page]="'analyst'"
        [columns]="columns"
        [gridUrl]="gridUrl"
        [showGridFilters]="showGridFilters"
        [sortKey]="sortKey"
        [(globalSearchVal)]="globalSearchVal"
        *ngIf="isDataSet"
      ></app-reporting-grid-wrapper>
    </div>
  </div>
</div>
